// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Cc9p5","notes":"Notes_notes__2LLZF","note":"Notes_note__1F9i8","markdown":"Notes_markdown__1xJR2"};